import type {Table as ReactTable} from '@tanstack/react-table';

import TableListView from '@/components/data-table/TableListView';
import type {Resident} from '@/services/graphqlHooks';

import ExportResidentsItem from './ExportResidentsListItem';

interface ExportResidentsListViewProps {
  table: ReactTable<Resident>;
}

const ExportResidentsListView = ({table}: ExportResidentsListViewProps) => {
  return (
    <TableListView className="grow divide-y">
      {table
        .getRowModel()
        .rows?.map(row => <ExportResidentsItem key={row.id} row={row} />)}
    </TableListView>
  );
};

export default ExportResidentsListView;
